/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Team } from './Team.js';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
} from './Team.js';

/**
 * 
 * @export
 * @interface GetTeamsResponse
 */
export interface GetTeamsResponse {
    /**
     * 
     * @type {Array<Team>}
     * @memberof GetTeamsResponse
     */
    data?: Array<Team>;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetTeamsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetTeamsResponse interface.
 */
export function instanceOfGetTeamsResponse(value: object): boolean {
    return true;
}

export function GetTeamsResponseFromJSON(json: any): GetTeamsResponse {
    return GetTeamsResponseFromJSONTyped(json, false);
}

export function GetTeamsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeamsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TeamFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetTeamsResponseToJSON(value?: GetTeamsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TeamToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

